<template>
  <div class="loot-boxes-list">
    <LootBoxBundle v-for="item in props.lootBoxes" :key="item.id" :item="item"></LootBoxBundle>
  </div>
</template>

<style scoped>
.loot-boxes-list {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-left: var(--margin-normal);
  margin-right: var(--margin-normal);
  gap: var(--margin-xs);
}
</style>

<script lang="ts" setup>
import {onMounted} from "vue";
import StoreItemDTO from "@/models/StoreItemDTO";
import LootBoxBundle from "@/components/store/LootBoxBundle.vue";

const props = defineProps<{
  lootBoxes: StoreItemDTO[]
}>()

onMounted(async () => {
})

</script>